import type { Vec2 } from './Vec2';
import { vec2, sub, scale, normalize, length } from './Vec2';

export const CANCEL_RADIUS = 30;
export const MAX_DRAG_DISTANCE = 200;
export const MAX_LAUNCH_SPEED = 1200;

export interface AimState {
  phase: 'idle' | 'aiming';
  touchOrigin: Vec2;
  dragPos: Vec2;
  direction: Vec2;
  power: number;
}

export function beginAim(touchPos: Vec2): AimState {
  return {
    phase: 'aiming',
    touchOrigin: touchPos,
    dragPos: touchPos,
    direction: vec2(0, 0),
    power: 0,
  };
}

export function updateAim(state: AimState, dragPos: Vec2): AimState {
  const drag = sub(dragPos, state.touchOrigin);
  const dist = length(drag);

  if (dist < CANCEL_RADIUS) {
    return {
      ...state,
      dragPos,
      direction: vec2(0, 0),
      power: 0,
    };
  }

  // Direction is opposite to drag
  const direction = normalize(scale(drag, -1));
  const power = Math.min(dist / MAX_DRAG_DISTANCE, 1);

  return {
    ...state,
    dragPos,
    direction,
    power,
  };
}

export function isInCancelZone(state: AimState): boolean {
  const drag = sub(state.dragPos, state.touchOrigin);
  return length(drag) < CANCEL_RADIUS;
}

export function getLaunchVelocity(state: AimState): Vec2 {
  if (state.power === 0) return vec2(0, 0);
  return scale(state.direction, state.power * MAX_LAUNCH_SPEED);
}

